// extracted by mini-css-extract-plugin
export var arrowLink = "WhatTwinDo-module--arrowLink--YSh2q";
export var card = "WhatTwinDo-module--card--ArCNC";
export var cardContent = "WhatTwinDo-module--cardContent--sGWRG";
export var cardImage = "WhatTwinDo-module--cardImage--HI+3m";
export var cardImageWrapper = "WhatTwinDo-module--cardImageWrapper--jezaH";
export var cardSubtitle = "WhatTwinDo-module--cardSubtitle--iRTN1";
export var cardTextWrapper = "WhatTwinDo-module--cardTextWrapper--Qke-z";
export var cardTitle = "WhatTwinDo-module--cardTitle--lo97X";
export var cardTitle2 = "WhatTwinDo-module--cardTitle2--07+pE";
export var cardsGrid = "WhatTwinDo-module--cardsGrid---CywD";
export var doctorsCard = "WhatTwinDo-module--doctorsCard--dFak+";
export var employersCard = "WhatTwinDo-module--employersCard--zCOvQ";
export var insurersCard = "WhatTwinDo-module--insurersCard--Kx8Et";
export var membersCard = "WhatTwinDo-module--membersCard--+u8P3";
export var sectionHeader = "WhatTwinDo-module--sectionHeader--RS2OH";
export var sectionSubtitle = "WhatTwinDo-module--sectionSubtitle--i09Ns";
export var sectionTitle = "WhatTwinDo-module--sectionTitle--WLfnP";
export var whatTwinDoWrapper = "WhatTwinDo-module--whatTwinDoWrapper--helpM";